<template>
  <section class="travel-quote-info">
    <div class="box">
      <h2>Policy Detail</h2>
      <div class="table mg-b-10">
        <div class="tr">
          <span>Effective Date</span>
          <span>{{ formData.pcy_cmnt_dt }}</span>
        </div>
        <div class="tr">
          <span>Expiry Date</span>
          <span>{{ formData.pcy_expry_date }}</span>
        </div>
        <div class="tr">
          <span>Studying Country</span>
          <span v-if="formData.country_id!=3">{{getAllOptionName25('study_country',formData.country_id)}}</span>
          <span v-else>{{getAllOptionName25('study_country',formData.country_id)}} - {{formData.other_country}}</span>
        </div>
      </div>
    </div>

    <div class="box">
      <h2>Policyholder Detail</h2>
      <div class="table">
        <div class="tr">
          <span>Title</span>
          <span>{{ getOptionName('titleOptions', formData.isrd_title) }}</span>
        </div>
        <div class="tr">
          <span>Last Name</span>
          <span>{{ formData.isrd_lst_nm }}</span>
        </div>
        <div class="tr">
          <span>First Name</span>
          <span>{{ formData.isrd_fst_nm }}</span>
        </div>
        <div class="tr">
          <span>Date of Birth</span>
          <span>{{ formData.isrd_dob_date }}</span>
        </div>
        <div class="tr">
          <span>Mobile Number</span>
          <span>{{ formData.mobile_no }}</span>
        </div>
        <div class="tr">
          <span>HKID Number</span>
          <span>{{ formData.id_no }}</span>
        </div>
        <!--        <div class="tr">-->
        <!--          <span>Email</span>-->
        <!--          <span>{{ formData.email }}</span>-->
        <!--        </div>-->
        <div class="tr">
          <span>Occupation</span>
          <span>{{ formData.occ }}</span>
        </div>
        <div class="tr">
          <span>Policyholder and student is the same person?</span>
          <span>{{getOptionName('yesNoOptions',formData.hldr_is_student_ind)}}</span>
        </div>
      </div>
      <h3>Correspondence Address</h3>
      <div class="table">
        <div class="tr">
          <span>Room</span>
          <span>{{ formData.addr_room }}</span>
        </div>
        <div class="tr">
          <span>Floor</span>
          <span>{{ formData.addr_floor }}</span>
        </div>
        <div class="tr">
          <span>Block</span>
          <span>{{ formData.addr_block }}</span>
        </div>
        <div class="tr">
          <span>Building / Estate</span>
          <span>{{ formData.addr_building }}</span>
        </div>
        <div class="tr">
          <span>Street</span>
          <span>{{ formData.addr_street }}</span>
        </div>
        <div class="tr">
          <span>District</span>
          <span>{{ getAreaName('district', formData.addr_district) }}</span>
        </div>
        <div class="tr">
          <span>Area</span>
          <span>{{ getAreaName('area', formData.addr_area) }}</span>
        </div>
        <div class="tr">
          <span>Country / Region</span>
          <span>{{ getAreaName('region', formData.addr_region) }}</span>
        </div>

      </div>

    </div>

    <div class="box">
      <h2>Insured Student Details</h2>
      <div class="table">
        <div class="tr">
          <span>Title</span>
          <span>{{ getOptionName('titleOptions', student_info.student_title) }}</span>
        </div>
        <div class="tr">
          <span>Last Name</span>
          <span>{{ student_info.student_lst_nm }}</span>
        </div>
        <div class="tr">
          <span>First Name</span>
          <span>{{  student_info.student_fst_nm }}</span>
        </div>
        <div class="tr">
          <span>HKID</span>
          <span>{{  student_info.student_id_no}}</span>
        </div>
        <div class="tr">
          <span>Date of Birth</span>
          <span>{{ student_info.student_dob }}</span>
        </div>
        <div class="tr">
          <span>Relationship</span>
          <span>{{ student_info.student_rel_language}}</span>
        </div>
        <div class="tr">
          <span>Overseas Studying Institution Name</span>
          <span>{{  student_info.student_ins_nm}}</span>
        </div>
        <div class="tr">
          <span>Overseas Studying Institution Address</span>
          <span>{{ student_info.student_addr}}</span>
        </div>
      </div>
    </div>
    <div
      v-if="hasAcc"
      class="box">
      <h2>Accompanying Parent or Guardian Details</h2>
      <div class="table">
        <div class="tr">
          <span>Title</span>
          <span>{{ getOptionName('titleOptions', acc_parent_info.student_title) }}</span>
        </div>
        <div class="tr">
          <span>Last Name</span>
          <span>{{ acc_parent_info.accompanying_lst_nm }}</span>
        </div>
        <div class="tr">
          <span>First Name</span>
          <span>{{  acc_parent_info.accompanying_fst_nm }}</span>
        </div>
        <div class="tr">
          <span>HKID</span>
          <span>{{  acc_parent_info.accompanying_id_no}}</span>
        </div>
        <div class="tr">
          <span>Date of Birth</span>
          <span>{{acc_parent_info.accompanying_dob }}</span>
        </div>
        <div class="tr">
          <span>Relationship to Insured Student</span>
          <span>{{ acc_parent_info.accompanying_rel_language}}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'

export default {
  name: 'quote-refer-info',
  mixins: [MixinOptions],

  props: {
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
    pcy_end_dt() {
      const { period_of_cvr, pcy_cmnt_dt } = this.formData
      if(pcy_cmnt_dt && period_of_cvr) {
        if(period_of_cvr >= 1) {
          return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
        }
        else {
          return dayjs(pcy_cmnt_dt).add(Number(period_of_cvr)*10, 'months').format('YYYY-MM-DD')
        }
        // return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
      }
      return ''
    },
    localAllOptions() {
      return this.allOptions25
    },
    student_info() {
      let {student_info}= this.formData||{}
      return student_info||{}
    },
    acc_parent_info() {
      let {acc_parent_info}= this.formData||{}
      return acc_parent_info||{}
    },
    hasAcc() {
      let {benefits=[]}= this.formData||{}
      return benefits.includes(2)
    },
  },
}
</script>

<style scoped>

</style>
